import _global3 from "../internals/global";
var exports = {};
var _global2 = _global3;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
exports = function (key, value) {
  try {
    defineProperty(_global2, key, {
      value: value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    _global2[key] = value;
  }
  return value;
};
export default exports;